<!--
  收货地址选择页面
-->
<template>
  <div class="address-container">
    <!--头部-->
    <titleHeader title="收货地址" ref="titlerHeader" @load-success="overLoadHeader" :cunstom-back="true" @goback="goback"></titleHeader>
    <!--收货地址list-->
    <div class="address-list" ref="addresslist">
      <div
        class="address-box"
        :class="{ 'active-class': selectedIndex == index }"
        v-for="(item, index) in addressList"
        @click="selectAddress(index)"
      >
        <span class="address-username">收货人：{{ item.name }} </span>
        <span class="address-tel">{{ item.tel }}</span>
        <div class="address-detail">
          <span class="default-address" v-show="item.isDefault === 1">默认</span>
          收货地址：{{ item.addressDetail }}
        </div>
        <div class="edit-address" @click.stop="editAddress(item)"><span>编辑</span></div>
      </div>
      <div class="no-data" v-show="nodata">暂无数据</div>
    </div>
    <div class="add-address" ref="addAddress" @click="gotoAddAddress">新增收货地址</div>
  </div>
</template>

<script>
import api from 'api/user';
import {mapState} from 'vuex';
import { Toast } from 'vant';
export default {
  data() {
    return {
      addressList: [],
      defaultAddress: {},
      selectedIndex: -1,
      ifFromSettle: 1,//是否从订单页进入
      nodata: false,
    };
  },
  computed: {
    ...mapState(['addressFrom'])
  },
  created() {
    this.getAddress();
    if(this.$route.query.index != undefined) {
      this.selectedIndex = this.$route.query.index;
      this.ifFromSettle = true;
    }else{
      this.ifFromSettle = false;
    }
  },
  mounted(){
    console.log(this.addressFrom);
  },
  methods: {
    //加载完头部后计算容器高度
    overLoadHeader() {
      this.$nextTick(function () {
        const bottomHeight = this.$refs.addAddress.offsetHeight;
        const headerHeight = this.$refs.titlerHeader.$el.offsetHeight;
        this.$refs.addresslist.style.height = window.innerHeight - bottomHeight - headerHeight + 'px';
      })
    },
    //返回订单页
    goback() {
      //是从订单页进入的
      if (this.addressFrom === 'settle') {
        if (this.addressList.length === 0) {
          Toast.fail('请添加收货地址');
          return
        }
        let params = {
          index : this.selectedIndex,
        };
        if (this.$route.query.standard) {
          params.standard = this.$route.query.standard;
        }
        this.$router.push({
          path: '/generate-settle',
          query: params,
        });
      }else if(this.addressFrom === 'mine'){
        this.$router.push({
          name: 'mine'
        })
      }else{
        this.$router.go(-1)
      }
    },
    async getAddress() {
      const data = await api.getAddress();
      this.addressList = data.records;
      data.records.map(item => {
        if (item.isDefault === 0) {
          this.defaultAddress = item;
        }
      });
      if (this.addressList.length === 0) {
        this.nodata = true;
      }else{
        this.nodata = false;
      }
    },
    //新增收货地址
    gotoAddAddress() {
      const params = {}
      if (this.$route.query.standard) {
          params.standard = this.$route.query.standard;
          params.index = this.selectedIndex;
        }
      this.$router.push({
        path: '/add-address',
        query: params,
      });
    },
    //选择收获地址
    selectAddress(index) {
      //是从个人中心的设置进入的,不触发事件
      if (!this.ifFromSettle) {
        return
      }
      let params = {
        index,
      };
      if (this.$route.query.standard) {
        params.standard = this.$route.query.standard;
      }
      this.$router.push({
        path: '/generate-settle',
        query: params,
      });
    },
    //编辑收货地址
    editAddress(item) {
      const params = {
        detail: JSON.stringify(item),
      }
      if (this.$route.query.standard) {
          params.standard = this.$route.query.standard;
          params.index = this.selectedIndex;
        }
      this.$router.push({
        path: '/add-address',
        query: params,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import 'common/sass/theme.scss';
.address-container {
  .address-list {
    overflow: auto;
    .address-box {
      position: relative;
      padding: 10px;
      border-bottom: 1px solid #efefef;
      .address-username {
        font-size: 18px;
      }
      .address-tel {
        font-size: 14px;
      }
      .address-detail {
        padding-right: 26px;
        font-size: 14px;
        color: $weight-word-color;
        .default-address {
          display: inline-block;
          padding: 0 5px;
          margin-right: 10px;
          font-size: 10px;
          color: $red-color;
          border: 1px solid $red-color;
          line-height: normal;
        }
      }
      .goto-address {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
      .edit-address {
        position: absolute;
        display: flex;
        right: 0px;
        top: 0;
        width: 50px;
        height: 100%;
        justify-content: center;
        align-items: center;
        font-size: 14px;
      }
    }
    .active-class {
      color: #fff;
      background: #5e6a7b;
      .address-detail {
        color: #fff;
      }
      .default-address {
        color: #fff;
      }
    }
  }
  .add-address {
    position: fixed;
    bottom: 0px;
    width: 100vw;
    height: 45px;
    line-height: 45px;
    background: $theme-color;
    text-align: center;
    color: #fff;
  }
}
</style>
